import { apiRequest } from '../config/api';

export interface VersionSummary {
  commit_sha: string;
  author: string;
  message: string;
  created_at: string;
  source: 'gitlab' | 'db';
}

export interface VersionContent extends VersionSummary {
  content: string;
  content_type: 'puml' | 'bpmn' | 'c4json' | 'structurizr';
}

export const diagramHistoryApi = {
  getHistory: (projectId: string, id: string): Promise<VersionSummary[]> =>
    apiRequest(`/projects/${encodeURIComponent(projectId)}/diagrams/${encodeURIComponent(id)}/history`, { method: 'GET' }),

  getVersion: (projectId: string, id: string, ref: string): Promise<VersionContent> =>
    apiRequest(
      `/projects/${encodeURIComponent(projectId)}/diagrams/${encodeURIComponent(id)}/version?ref=${encodeURIComponent(ref)}`,
      { method: 'GET' },
    ),
};
